import React, { useEffect } from "react";

const leistungen = [
  {
    title: "Löschung unfairer Online-Bewertungen",
    content: [
      "Nicht jede negative Bewertung muss hingenommen werden. Viele Rezensionen auf Google, Trustpilot, Kununu, Jameda oder Booking.com verstoßen gegen Plattform-Richtlinien oder geltendes Recht – und können entfernt werden.",
      "Als Rechtsanwalt mit über 14 Jahren Erfahrung im Reputationsrecht prüfe ich Ihre Bewertungen auf:",
    ],
    list: [
      "Verstöße gegen die Richtlinien der jeweiligen Plattform",
      "Schmähkritik und Beleidigungen",
      "Unwahre Tatsachenbehauptungen",
      "Bewertungen ohne erkennbaren Kundenkontakt",
      "Verstöße gegen den Digital Services Act (DSA)",
    ],
    afterList: [
      "In Zusammenarbeit mit meinem Team bei Fairebewertungen.de reiche ich den Löschantrag bei der Plattform ein und begleite den gesamten Prozess. Unsere Erfolgsquote liegt bei 96 %.",
      "Sie zahlen ausschließlich bei erfolgreicher Löschung.",
    ],
    cta: {
      text: "Löschung beantragen auf Fairebewertungen.de",
      href: "https://www.fairebewertungen.de/kontakt",
    },
  },
  {
    title: "Europäisches Internetrecht & DSA",
    content: [
      "Der Digital Services Act (DSA) hat die Regeln für Online-Plattformen in der EU grundlegend verändert. Als registrierter EU-Experte bei der Europäischen Kommission berate ich Unternehmen zu ihren Rechten und Pflichten im digitalen Raum.",
      "Meine Beratungsschwerpunkte:",
    ],
    list: [
      "Rechte gegenüber Online-Plattformen nach dem DSA",
      "Melde- und Abhilfeverfahren nach Art. 16 DSA",
      "Transparenzpflichten und Haftungsfragen",
      "Grenzüberschreitende Rechtsdurchsetzung in der EU",
    ],
  },
  {
    title: "Persönlichkeitsrecht im Internet",
    content: [
      "Rufschädigende Inhalte im Internet können existenzbedrohend sein. Ich unterstütze Sie bei der Durchsetzung Ihrer Persönlichkeitsrechte:",
    ],
    list: [
      "Unterlassungsansprüche gegen Verfasser",
      "Löschungsansprüche gegen Plattformbetreiber",
      "Gegendarstellungen und Richtigstellungen",
      "Schadensersatzforderungen bei Rufschädigung",
    ],
  },
  {
    title: "Strategisches Reputationsmanagement",
    content: [
      "Prävention ist besser als Reaktion. Ich berate Unternehmen beim strategischen Aufbau und Schutz ihrer Online-Reputation:",
    ],
    list: [
      "Monitoring aller relevanten Bewertungsplattformen",
      "Frühwarnsysteme bei negativen Entwicklungen",
      "Rechtliche Rahmenbedingungen für Bewertungsmanagement",
      "Schulung von Mitarbeitern im Umgang mit Bewertungen",
    ],
  },
];

export default function Leistungen() {
  useEffect(() => {
    document.title =
      "Leistungen – Bewertungen löschen, Internetrecht, DSA | RA Sindros";
    const meta = document.querySelector('meta[name="description"]');
    if (meta)
      meta.setAttribute(
        "content",
        "Unfaire Google-Bewertung? Rechtsanwalt Sindros löscht Bewertungen auf Google, Trustpilot, Kununu und mehr. 96% Erfolgsquote. Zahlung nur bei Erfolg."
      );
  }, []);

  return (
    <div>
      {/* Hero */}
      <section className="bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20 lg:py-28">
          <h1
            className="text-4xl lg:text-5xl font-bold mb-6"
            style={{
              color: "#1B3A5C",
              fontFamily: "'Source Serif 4', serif",
            }}
          >
            Leistungen
          </h1>
          <p className="text-lg max-w-2xl" style={{ color: "#555555" }}>
            Spezialisiert auf Internetrecht und die Durchsetzung Ihrer Rechte im
            digitalen Raum.
          </p>
        </div>
      </section>

      {/* Leistungen */}
      {leistungen.map((leistung, index) => (
        <section
          key={index}
          style={{
            backgroundColor: index % 2 === 0 ? "#F5F5F5" : "#FFFFFF",
          }}
        >
          <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 lg:py-24">
            <div className="max-w-3xl">
              <h2
                className="text-2xl lg:text-3xl font-bold mb-8"
                style={{
                  color: "#1B3A5C",
                  fontFamily: "'Source Serif 4', serif",
                }}
              >
                {leistung.title}
              </h2>

              {leistung.content.map((para, pIndex) => (
                <p
                  key={pIndex}
                  className="text-base leading-relaxed mb-6"
                  style={{ color: "#555555" }}
                >
                  {para}
                </p>
              ))}

              {leistung.list && (
                <ul className="space-y-3 mb-8 ml-6">
                  {leistung.list.map((item, lIndex) => (
                    <li
                      key={lIndex}
                      className="text-base leading-relaxed relative pl-5"
                      style={{ color: "#555555" }}
                    >
                      <span
                        className="absolute left-0 top-[10px] w-1.5 h-1.5 rounded-full"
                        style={{ backgroundColor: "#2E75B6" }}
                      />
                      {item}
                    </li>
                  ))}
                </ul>
              )}

              {leistung.afterList && (
                <div className="space-y-4">
                  {leistung.afterList.map((para, aIndex) => (
                    <p
                      key={aIndex}
                      className="text-base leading-relaxed"
                      style={{ color: "#555555" }}
                    >
                      {para}
                    </p>
                  ))}
                </div>
              )}

              {leistung.cta && (
                <div className="mt-10">
                  <a
                    href={leistung.cta.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block px-8 py-4 text-white font-medium text-sm rounded"
                    style={{
                      backgroundColor: "#1B3A5C",
                      transition: "opacity 0.2s ease",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.opacity = "0.88")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.opacity = "1")
                    }
                  >
                    {leistung.cta.text}
                  </a>
                </div>
              )}
            </div>
          </div>
        </section>
      ))}
    </div>
  );
}
